import React, { Fragment } from "react";

import Templates from "./Templates";
import RequirementType from "./RequirementType";
import UnitOfMeasure from "./UnitOfMeasure";
import TemplateCategory from "./TemplateCategory";

const Purchasing = () => {
  return (
    <Fragment>
      <RequirementType />
      <Templates />
      <TemplateCategory />
      <UnitOfMeasure />
    </Fragment>
  );
};

export default Purchasing;
